import React from 'react'

import DateFnsUtils from '@date-io/date-fns'
import { Box, Checkbox, FormControlLabel, makeStyles, IconButton } from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'

import FilterInput from './FilterInput'

import { SearchIcon } from 'components/icons/personalizedIcons'
import { FILTER_WARRANTIES_VALUE, FILTER_RETACTS_VALUE } from 'constants/filters'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  select: {
    minWidth: 100,
  },
  chip: {
    height: 32,
    marginLeft: theme.spacing(1),
  },
  datePicker: {
    width: 140,
  },
  iconContainer: {
    width: 24,
    height: 24,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  unchecked: {
    backgroundColor: '#fff',
    border: '2px solid #6064FF',
  },
  checked: {
    backgroundColor: '#6064FF',
  },
  checkIcon: {
    color: '#fff',
    fontSize: 18,
  },
}))

const FiltersBar = ({
  customFilter,
  request,
  setCustomFilter,
  handleCheckWarrantiesAndRetacts,
  handleNewFilter,
  setDate,
  date,
}) => {
  const classes = useStyles()
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Box className={classes.root}>
        <FilterInput
          customFilter={customFilter}
          setCustomFilter={setCustomFilter}
          handleNewFilter={handleNewFilter}
        />
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={
                !!request.filters.find(
                  (filter) => filter.value === FILTER_WARRANTIES_VALUE && filter.type === 3
                )
              }
              onChange={(e) => {
                handleCheckWarrantiesAndRetacts(3, 1, e.target.checked)
              }}
              icon={<span className={`${classes.iconContainer} ${classes.unchecked}`} />}
              checkedIcon={
                <span className={`${classes.iconContainer} ${classes.checked}`}>
                  <CheckIcon className={classes.checkIcon} />
                </span>
              }
            />
          }
          label="Garantías"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={
                !!request.filters.find(
                  (filter) => filter.value === FILTER_RETACTS_VALUE && filter.type === 3
                )
              }
              onChange={(e) => {
                handleCheckWarrantiesAndRetacts(3, 3, e.target.checked)
              }}
              icon={<span className={`${classes.iconContainer} ${classes.unchecked}`} />}
              checkedIcon={
                <span className={`${classes.iconContainer} ${classes.checked}`}>
                  <CheckIcon className={classes.checkIcon} />
                </span>
              }
            />
          }
          label="Retractos"
        />

        <DatePicker
          autoOk
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          value={date.initialDate}
          onChange={(initDate) => {
            if (initDate) {
              const formattedDate = moment(initDate).startOf('day').add(1, 'minute').toISOString()
              setDate({ ...date, initialDate: formattedDate })
            }
          }}
          maxDate={new Date()}
          placeholder="Desde"
          className={classes.datePicker}
        />

        <DatePicker
          autoOk
          variant="inline"
          inputVariant="outlined"
          format="MM/dd/yyyy"
          value={date.finalDate}
          onChange={(finalDate) => {
            if (finalDate) {
              const formattedDate = moment(finalDate)
                .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
                .toISOString()

              setDate({ ...date, finalDate: formattedDate })
            }
          }}
          maxDate={new Date()}
          placeholder="Hasta"
          className={classes.datePicker}
        />
        <IconButton onClick={handleNewFilter}>
          <SearchIcon />
        </IconButton>
      </Box>
    </MuiPickersUtilsProvider>
  )
}

export default FiltersBar
